module.exports = __webpack_public_path__ + "static/img/人像.f1abf47a.png";